// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1CObu","reports":"styles__reports___10JHf","widgets":"styles__widgets___3XdNM","body":"styles__body___13s1D","show":"styles__show___UVaxL"};